<script setup>
import { ref, watch, nextTick } from 'vue';
import { useToggle, useEventListener } from '@vueuse/core';
import { provideDropdownContext } from './provider.js';

const emit = defineEmits(['close']);
const [isOpen, toggle] = useToggle(false);
const containerRef = ref(null);
const dropdownRef = ref(null);
const dropdownStyle = ref({});

const updatePosition = () => {
  if (!containerRef.value) return;
  const rect = containerRef.value.getBoundingClientRect();
  dropdownStyle.value = {
    position: 'fixed',
    top: `${rect.bottom + 4}px`,
    left: `${rect.left}px`,
    zIndex: 9999,
  };
};

const closeMenu = () => {
  if (isOpen.value) {
    emit('close');
    toggle(false);
  }
};

watch(isOpen, async newVal => {
  if (newVal) {
    await nextTick();
    updatePosition();
  }
});

useEventListener(window, 'resize', () => {
  if (isOpen.value) updatePosition();
});

useEventListener(
  window,
  'scroll',
  () => {
    if (isOpen.value) updatePosition();
  },
  { capture: true }
);

useEventListener(document, 'pointerdown', event => {
  if (!isOpen.value) return;
  if (containerRef.value?.contains(event.target)) return;
  if (dropdownRef.value?.contains(event.target)) return;
  closeMenu();
});

provideDropdownContext({
  isOpen,
  toggle,
  closeMenu,
});
</script>

<template>
  <div ref="containerRef" class="relative space-y-2">
    <slot name="trigger" :is-open :toggle="() => toggle()" />
    <Teleport to="body">
      <div
        v-if="isOpen"
        ref="dropdownRef"
        data-dropdown-content
        :style="dropdownStyle"
      >
        <slot />
      </div>
    </Teleport>
  </div>
</template>
